import { GET_AUTH_TOKEN, IS_AUTH_ADMIN, LOGOUT_AUTH, SET_AUTH_LOADING, STORE_AUTH_TOKEN } from "../actions/auth.action";

export default (
  state = {
    token: sessionStorage.getItem("access_token") || null,
    loading: false,
    isAdmin: null,
  },
  { type, data }
) => {
  switch (type) {
    case GET_AUTH_TOKEN:
      return { ...state, loading: true };
    case STORE_AUTH_TOKEN:
      return { ...state, token: data, loading: false };
    case IS_AUTH_ADMIN:
      return { ...state, isAdmin: data, loading: false };
    case SET_AUTH_LOADING:
      return { ...state, loading: true };
    case LOGOUT_AUTH:
      return { ...state, token: null, loading: false, isAdmin: null };
    default:
      return state;
  }
};
